import { EcomerceService } from "../../services/ecommerce.service";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { AppService } from "../../../app.service";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PoliticaPrivacidadeComponent } from "src/app/pages/politica-privacidade/politica-privacidade.component";
import { AmostraPoliticaPrivacidadeComponent } from "src/app/pages/amostra-politica-privacidade/amostra-politica-privacidade.component";

@Component({
  selector: "app-footer-one",
  templateUrl: "./footer-one.component.html",
  styleUrls: ["./footer-one.component.scss"],
})
export class FooterOneComponent implements OnInit {
  @Input() class: string = "footer-light"; // Default class
  @Input() themeLogo: string = "assets/images/icon/logo.png"; // Default Logo
  @Input() newsletter: boolean = true; // Default True

  public modalOpen: boolean = false;
  public closeResult: string;

  public today: number = Date.now();

  public msgForm: UntypedFormGroup;

  constructor(
    public ecomerceService: EcomerceService,
    private formGroup: UntypedFormBuilder,
    public appService: AppService,
    private modalService: NgbModal
  ) {
    this.msgForm = this.formGroup.group({
      email: [null, Validators.required],
    });
  }

  ngOnInit(): void {}

  enviarNewsLetter() {
    if (this.msgForm.valid) {
      const dadosTratados = {
        idNewsletter: 0,
        idEmpresa: 1,
        email: this.msgForm.value.email,
      };
      this.ecomerceService.enviarNewsLetter(dadosTratados).subscribe(
        (res) => {
          this.msgForm.reset();
          this.appService.SwalSucessoNewsletter();
        },
        (err) => {
          this.appService.SwalErrorMSGEnviada();
        }
      );
    } else {
      this.appService.SwalError();
    }
  }

  openModal() {
    const modalRef = this.modalService.open(AmostraPoliticaPrivacidadeComponent, {
      backdrop: "static",
      centered: true,
      size: "xl",
      scrollable: true,
      
    });
    modalRef.result.then((result) => {});
  }
}
